import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class aboutOrganizer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <Header />
                <main className="main-area fix">
                    {/* breadcrumb-area */}
                    <div
                        className="breadcrumb__area breadcrumb__bg"
                        data-background="assets/img/aboutUs_img.jpg"
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="breadcrumb__content">
                                        {/* <h2 class="title">About Us</h2> */}
                                        <nav className="breadcrumb">
                                            <span property="itemListElement" typeof="ListItem">
                                                <a href="index.html">Home</a>
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span property="itemListElement" typeof="ListItem">
                                                Event Info
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span
                                                className="beadcrumb-active"
                                                property="itemListElement"
                                                typeof="ListItem"
                                            >
                                                About Organizer
                                            </span>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* breadcrumb-area-end */}
                    {/* about-area */}
                    <section className="about_section">
                        <div className="container">
                            <div className="row">
                                <div
                                    className="col-lg-6 col-sm-6"
                                    data-aos="fade-right"
                                    data-aos-delay={300}
                                >
                                    <div className="about-content">
                                        {/* <h4 class="border_title">About</h4> */}
                                        <div className="selector">
                                            <h2 className="ah-headline letters rotate-3">
                                                {/* <p>Conference Organisation</p> */}
                                                <span className="position_relative">INDIA ITME Society</span>
                                            </h2>
                                        </div>
                                        <p>
                                            India International Textile Machinery Exhibitions Society (India
                                            ITME Society), a 45 year old non profit apex industry body,
                                            established in 1980, to support and serve the Textile Engineering
                                            Industry through Exhibitions &amp; Events.
                                        </p>
                                        <p>
                                            India ITME Society was conceived with a Vision to play a pivotal
                                            role in strengthening the Indian Textile Engineering Industry by
                                            facilitating exchange of knowledge, technology transfer &amp;
                                            foreign investment in the sector and to be the apex exhibition
                                            body in India for the textile machinery, accessories and component
                                            industry.
                                        </p>
                                        <p>
                                            The organisation and its team works relentlessly towards its
                                            Mission to aid, stimulate, promote, encourage &amp; support trade
                                            and commerce with a focus on Textile Engineering and allied
                                            industries, through exhibitions and conferences, thus propagating
                                            the cause of Textile Engineering Industry at National and
                                            International levels.
                                        </p>
                                        <p>
                                            With the motto of empowering Textiles through Trade &amp;
                                            Technology, India ITME Society relentlessly spots the right
                                            opportunities that will contribute to the greater good. Over the
                                            years India ITME Society has evolved into the next level,
                                            metamorphosing from an Indian organiser to a global phenomenon
                                            embracing internationalism exploring &amp; connecting emerging
                                            economies to Indian Textile &amp; Engineering Industry.
                                        </p>
                                        <p>
                                            The society has left no stones unturned in establishing itself as
                                            one of India’s most successful exhibition organizers with its
                                            principles based on trust, consistency &amp; collaboration.
                                        </p>
                                        <ul>
                                            <li>
                                                For more information visit :{" "}
                                                <a href="https://corporate.india-itme.com/" target="_blank">
                                                    click here
                                                </a>
                                            </li>
                                            <li>
                                                To view the brochure click :{" "}
                                                <a
                                                    href="https://corporate.india-itme.com/Corporate-Flipbook/"
                                                    target="_blank"
                                                >
                                                    click here
                                                </a>
                                            </li>
                                            <li>
                                                To view the video click :{" "}
                                                <a
                                                    href="https://www.youtube.com/watch?v=krrTau-uvCw"
                                                    target="_blank"
                                                >
                                                    click here
                                                </a>
                                            </li>
                                            <li>
                                                India ITME Society today organizes exhibitions every year,
                                                addressing different requirements of the industry segment under
                                                its banner.
                                            </li>
                                        </ul>
                                        <ol>
                                            <li>
                                                India International Textile Machinery Exhibition{" "}
                                                <strong>(INDIA ITME)</strong> – Flagship event since 1980
                                                completing 44 years)
                                            </li>
                                            <li>
                                                Global Textile Technology &amp; engineering show{" "}
                                                <strong>(GTTES)</strong> – Focused on SME sector and regional
                                                hubs)
                                            </li>
                                            <li>
                                                International Technology, Machinery &amp; Engineering Exhibition{" "}
                                                <strong>(ITME AFRICA &amp; MIDDLE EAST)</strong> (overseas
                                                edition).
                                            </li>
                                            <li>
                                                India ITME Virtual Buyer Seller Meet{" "}
                                                <strong>(ITME Virtual BSM)</strong>
                                            </li>
                                        </ol>
                                        <p>
                                            India ITME Society is a trend setter for out of box ideas in
                                            serving the industry members, not limited to India, but in Africa,
                                            Middle East and other frontiers as well. India ITME Society’s
                                            relentless passion to innovate &amp; excel forward towards new
                                            goals have resulted in a plethora of upcoming projects such as
                                        </p>
                                        <p>
                                            <strong style={{ color: "#FFA800" }}>
                                                01. ITME Trade Services
                                            </strong>{" "}
                                            which shall offer
                                        </p>
                                        <ol type="a">
                                            <li>Trade Missions : Inbound &amp; Outbound</li>
                                            <li>Trade Enquiry : For Business Opportunities</li>
                                            <li>Trade Information : Knowledge Sessions &amp; Webinars</li>
                                            <li>India Pavilion at International Exhibition</li>
                                            <li>Project Consultancy</li>
                                        </ol>
                                        <p>
                                            For more information visit :{" "}
                                            <a href="https://tradedesk.india-itme.com/" target="_blank">
                                                click here
                                            </a>
                                        </p>
                                        <p>
                                            <strong style={{ color: "#FFA800" }}>
                                                02. India ITME Awards
                                            </strong>{" "}
                                            one &amp; only award exclusive for Textile Technology &amp;
                                            Engineering Sector.
                                        </p>
                                        <p>
                                            For more information visit :{" "}
                                            <a href="https://awards.india-itme.com/" target="_blank">
                                                click here
                                            </a>
                                        </p>
                                        <p>
                                            Humility of action, integrity of purpose and transparency of
                                            conduct are the key traits driving the Society’s growth and its
                                            journey forward.{" "}
                                            <strong>
                                                “India ITME Society – Empowering Textiles through Trade &amp;
                                                Technology.”
                                            </strong>
                                        </p>
                                        <img src="assets/img/about_org_img_new.png" />
                                    </div>
                                </div>
                                <div
                                    className="col-lg-6 col-sm-6"
                                    data-aos="fade-left"
                                    data-aos-delay={300}
                                >
                                    <div className="position_relative f-right">
                                        <div className="about_img">
                                            <img
                                                src="assets/img/about_org_img_bg.png"
                                                alt="Choose Us"
                                                loading="lazy"
                                            />
                                            <div className="triangle-down" />
                                            <div className="experience_year">
                                                <img src="assets/img/mark-about-counter.png" />
                                                <div className="d-flex align-items-center">
                                                    <h1>45</h1>
                                                    <h3>
                                                        YEAR
                                                        <br />
                                                        EXPERIENCE
                                                    </h3>
                                                </div>
                                            </div>
                                            <a
                                                href="https://www.youtube.com/watch?v=h3vbPxz6Wzc"
                                                target="_blank"
                                                className="popup-video-link video-popup__button"
                                            >
                                                <i className="fas fa-play" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="awards_section">
                        <div className="container">
                            <div className="row" data-aos="fade-up" data-aos-delay={300}>
                                <div className="col-md-12 text-center">
                                    {/* <h4 class="border_title">Awards</h4> */}
                                    <div className="selector">
                                        <h2 className="ah-headline letters rotate-3">
                                            {/* <p>Conference Organisation</p> */}
                                            <span className="position_relative yellow_color">
                                                AWARDS &amp; Recognition
                                            </span>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            <div className="awrds_nav_btns">
                                <div className="project__nav" data-aos="fade-left" data-aos-delay={200}>
                                    <button className="testimonial-button-prev">
                                        <i className="renova-left-arrow" />
                                    </button>
                                    <button className="testimonial-button-next">
                                        <i className="renova-right-arrow" />
                                    </button>
                                </div>
                            </div>
                            <div className="row" data-aos="fade-up" data-aos-delay={500}>
                                <div className="col-md-12">
                                    <div className="swiper AwardSwiper">
                                        <div className="swiper-wrapper">
                                            <div className="swiper-slide">
                                                <div className="award_item">
                                                    <div className="card award_card">
                                                        <div className="card-body">
                                                            <img src="assets/img/awards/award_11.jpg" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="swiper-slide">
                                                <div className="award_item">
                                                    <div className="card award_card">
                                                        <div className="card-body">
                                                            <img src="assets/img/awards/award_22.jpg" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="swiper-slide">
                                                <div className="award_item">
                                                    <div className="card award_card">
                                                        <div className="card-body">
                                                            <img src="assets/img/awards/award_33.jpg" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12"></div>
                            </div>
                        </div>
                    </section>
                    <section className="Opportunities_section">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <h3 className="yellow_color">
                                        Empowering Textile Industry Through Technology
                                    </h3>
                                    <p>
                                        The Society offers three keys International B2B exhibitions creating
                                        maximum opportunities for the Industry.
                                    </p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="grid_view_div">
                                        <div>
                                            <img src="assets/img/ITME-Africa-01_11.png" />
                                            <h6>
                                                04th to 09th December 2026
                                                <br />
                                                India Expo Center &amp; Mart, IEML, Greater Noida
                                            </h6>
                                        </div>
                                        <div>
                                            <img src="assets/img/ITME-Africa-01.jpg" />
                                            <h6>December 2026</h6>
                                        </div>
                                        <div>
                                            <img src="assets/img/GTTS_Logo_without_year_1.jpg" />
                                            <h6>GTTES</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>

                <Footer />
            </>
        )

    }
}

export default withRouter(connect(null, {})(aboutOrganizer));